import { getSafeUi } from '@tectonics/prs/incoming-payment';
 
function getDisabledCustomerNameField(ui) {
  return ui['readonly_customer_name_field'];
}
 
export function shouldDisabledCustomerNameField(incomingPayment) {
  const ui = getSafeUi(incomingPayment);
  return !!getDisabledCustomerNameField(ui);
}
